module.exports = __webpack_public_path__ + "img/banner-about.f52c3d26.jpg";